import { HamburgerIcon } from "assets";
import dropdownActiveIcon from "assets/Resources/dropdown-active-icon.svg";
import menuRightIcon from "assets/Resources/menu-right-icon.svg";
import { useAuth } from "../../../providers/AuthProvider";
import clsx from "clsx";
import React, { ReactElement, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Images } from "assets/Images";

interface SidebarProps {
  primary?: boolean;
  backgroundColor?: string;
  size?: "small" | "medium" | "large";
  userInfo?: any;
  menuOptions?: Array<MenuOption>;
  onChange?: () => void;
  className: any;
  style?: object;
  toggleSubMenu?: any;
  openSubMenu?: any;
  siteLogo?: any;
  isGradient?: boolean;
}

interface MenuOption {
  name: string;
  path?: string;
  leftIcon: ReactElement;
  subMenu?: Array<SubMenuOption>;
}

interface SubMenuOption {
  name: string;
  path: string;
  leftIcon?: React.ReactElement;
}

export const Sidebar = ({
  primary = false,
  size = "medium",
  backgroundColor,
  userInfo,
  menuOptions,
  onChange,
  className,
  style,
  siteLogo,
  isGradient,
  ...props
}: SidebarProps) => {
  const navigation = useNavigate();
  const { pathname } = useLocation();
  const location = useLocation();
  const { logout } = useAuth();
  console.log(userInfo, "userInfouserInfo");
  const [openSubMenu, setOpenSubMenu] = useState<number | null>(null);
  const [isOpen, setIsOpen] = useState(false);
  const slideBarRef = useRef<HTMLDivElement>(null);
  const hamburgerRef = useRef<HTMLDivElement>(null);
  const [isMobileScreen, setIsMobileScreen] = useState(
    window.innerWidth < 1024
  );

  const toggleSubMenu = (index: number) => {
    openSubMenu == index ? setOpenSubMenu(null) : setOpenSubMenu(index);
  };

  const handleNavigate = (path: string) => {
    if (isOpen) {
      setIsOpen(false);
    }
    navigation(path);
  };

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobileScreen(window.innerWidth < 1024);
    };

    window.addEventListener("resize", handleResize);

    // Cleanup the listener when the component unmounts
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (isMobileScreen && isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    // Optional cleanup (resets overflow if component unmounts)
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isMobileScreen, isOpen]);

  useEffect(() => {
    function handleClose(e: MouseEvent) {
      if (
        slideBarRef.current &&
        !slideBarRef.current.contains(e.target as Node) &&
        hamburgerRef.current &&
        !hamburgerRef.current.contains(e.target as Node)
      ) {
        setIsOpen(false); // or your close handler
      }
    }
    if (isOpen) {
      document.addEventListener("mousedown", handleClose);
    }
    return () => document.removeEventListener("click", handleClose);
  }, [isOpen]);

  return (
    <>
      <div
        ref={hamburgerRef}
        className={` left-3 top-[18px] z-[10010] cursor-pointer  max-sm:z-[10021] lg:hidden ${isOpen ? "!text-white" : "!text-[#666666]"} transition-colors ${pathname.includes("editor") ? "hidden" : "fixed"}`}
        onClick={toggleSidebar}
      >
        <HamburgerIcon isOpen={isOpen} />
      </div>
      <div
        className={`fixed left-0 top-0 z-[10002] h-full w-full bg-black/70 ${isOpen && isMobileScreen ? "fixed" : "hidden"} lg:hidden`}
      >
        {" "}
      </div>
      <div
        ref={slideBarRef}
        className={clsx(
          "fixed top-0 z-[10002]  h-screen w-80 min-w-247 flex-col bg-white shadow-lg transition-transform duration-300 ease-in-out max-sm:z-[10020] max-sm:w-full lg:sticky lg:top-0 lg:shadow-none",
          className,
          isOpen ? "translate-x-0" : "-translate-x-full",
          "lg:translate-x-0",
          pathname.includes("editor") ? "hidden" : "flex"
        )}
        style={{
          ...style,
          // height: isOpen && isMobileScreen ? "calc(100vh - 64px)" : "100vh",
          overflowY: "auto",
        }}
      >
        {/* Top Section */}
        {isGradient ? (
          <div className="relative flex h-40 items-center justify-center bg-gradient-to-r from-[#7213EA] to-[#1E49E2]">
            <div className="mb-7">
              <img src={siteLogo} alt="kpmgLogo" />
            </div>
            <div className="item-center absolute -bottom-1/2 flex h-[130px] w-[130px] justify-center">
              <img
                className="h-full w-full rounded-full border-[3px] border-[#F4F3F380] object-cover"
                src={
                  userInfo?.avatar === "null" || !userInfo?.avatar
                    ? Images.AVATAR
                    : userInfo?.avatar
                }
                alt="Logo"
              />
            </div>
          </div>
        ) : (
          <div className="relative flex h-40 items-center justify-center">
            <img
              className="h-full w-full object-cover"
              src={userInfo.banner || Images.BANNER}
              style={{
                width: !userInfo?.banner ? "80%" : "100%",
                height: !userInfo?.banner ? "auto" : "100%",
              }}
              alt="ban"
            />
            <div className="item-center absolute -bottom-1/2 flex h-[130px] w-[130px] justify-center">
              <img
                className="h-full w-full rounded-full border-[3px] border-[#F4F3F380] object-cover shadow-md"
                src={
                  userInfo?.avatar === "null" || !userInfo?.avatar
                    ? Images.AVATAR
                    : userInfo?.avatar
                }
                alt="Logo"
              />
            </div>
          </div>
        )}

        {/* Scrollable Menu Section */}
        <div className="mt-8 flex flex-grow flex-col overflow-y-auto overflow-x-hidden py-3">
          <div className="mb-4 mt-14 text-center">
            <h3 className="break-words px-5 text-lg font-semibold leading-6 text-light-gray-900">
              {userInfo?.name}
            </h3>
            <p className="break-all px-5 text-[13px] text-light-gray-300">
              {userInfo?.userEmail}
            </p>
          </div>

          {menuOptions &&
            menuOptions.map((item: MenuOption, index: number) => {
              const hasSubMenu = item?.subMenu && item.subMenu.length > 0;
              const isSubMenuOpen = item.subMenu?.find(
                (subItem: SubMenuOption) => location.pathname === subItem.path
              );
              return (
                <div key={item.name} className="flex w-full cursor-pointer">
                  <div
                    className={`my-1 w-1 rounded-br-sm rounded-tr-sm bg-light-primary-500 transition-all duration-500 ease-in-out ${
                      location.pathname === item.path || isSubMenuOpen
                        ? "visible opacity-100"
                        : "invisible opacity-0"
                    }`}
                  />

                  <div className="w-full">
                    <div
                      className={clsx(
                        "flex cursor-pointer items-center justify-between transition-all duration-300 hover:bg-light-primary-50",
                        location.pathname === item.path || isSubMenuOpen
                          ? "pe-6 ps-5 text-light-primary-500"
                          : "px-6 text-light-gray-900"
                      )}
                      onClick={() =>
                        hasSubMenu
                          ? toggleSubMenu(index)
                          : item.path && handleNavigate(item.path)
                      }
                    >
                      <div className="flex w-full items-center gap-2 border-t-2 border-background-50 py-3">
                        <span className="">{item?.leftIcon}</span>
                        <div className="font-medium">{item?.name}</div>
                      </div>
                      <div>
                        {hasSubMenu && (
                          <img
                            src={
                              openSubMenu !== index
                                ? menuRightIcon
                                : dropdownActiveIcon
                            }
                            alt="dropdown"
                          />
                        )}
                      </div>
                    </div>
                    {hasSubMenu && (
                      <div
                        className={clsx(
                          "transition-all",
                          openSubMenu === index ? "block" : "hidden"
                        )}
                      >
                        {item.subMenu &&
                          item?.subMenu.map((subItem: SubMenuOption) => (
                            <div
                              key={subItem?.name}
                              className={clsx(
                                "align-center group flex w-full cursor-pointer justify-between py-3 pl-9 transition-all hover:bg-light-primary-50 hover:text-light-primary-500",
                                location.pathname === subItem.path
                                  ? "text-light-primary-500"
                                  : "text-light-gray-900"
                              )}
                              onClick={() => {
                                if (subItem.path === "/log-out") {
                                  logout("LOGIN");
                                  return;
                                }
                                handleNavigate(subItem.path);
                              }}
                            >
                              <div className="flex w-full items-center gap-3">
                                <div
                                  className={clsx(
                                    "h-[6px] w-[6px] rounded-full transition-all duration-500 ease-in-out group-hover:scale-150 group-hover:bg-light-primary-500",
                                    location.pathname === subItem.path
                                      ? "scale-150 bg-light-primary-500"
                                      : "scale-100 bg-light-gray-300"
                                  )}
                                />
                                <div>{subItem?.name}</div>
                              </div>
                            </div>
                          ))}
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
};
